import { ApplicationConfig, ErrorHandler, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from "./app.routes";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideStore } from '@ngrx/store';
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { ConfirmationService, MessageService } from "primeng/api";
import { baseUrlInterceptor } from "@app/core/http/base-url.interceptor";
import { AppErrorHandler } from "@app/core/error/AppErrorHandler";
import { provideNoopAnimations } from "@angular/platform-browser/animations";
import { ConfirmDialog } from "primeng/confirmdialog";
import { DialogService } from "primeng/dynamicdialog";
import { DatePipe } from "@angular/common";
import { sendTokenInterceptor } from "@app/core/auth/send-token.interceptor";
import { refreshTokenInterceptor } from "@app/core/auth/refresh-token.interceptor";
import { provideNchlUi } from "@nchl/ngx-ui/core";
import initTenantConfig from './core/tenant/initTenantConfig';
import {
  nchlCalendar,
  nchlCheck,
  nchlCheckCircle,
  nchlHome,
  nchlKey,
  nchlWallet,
  lucideArrowRightLeft,
  lucideBadgeDollarSign,
  lucideBan,
  lucideBanknote,
  lucideBell,
  lucideBuilding,
  lucideChartBar,
  lucideSquare,
  lucideClock,
  lucideCreditCard,
  lucideEraser,
  lucideFileCheck,
  lucideFileInput,
  lucideFileMinus,
  lucideFileText,
  lucideLink,
  lucideCog,
  lucideMail,
  lucidePackage,
  lucidePercent,
  lucidePower,
  lucideRefreshCw,
  lucideSend,
  lucideSettings,
  lucideShare2,
  lucideShield,
  lucideThumbsUp,
  lucideTruck,
  lucideUserCheck,
  lucideWrench,
  lucideUserPen,
  lucideUser
} from "@nchl/ngx-ui/icons";

export const appConfig: ApplicationConfig = {
  providers: [
    provideNoopAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideStore(),
    provideHttpClient(withInterceptors([baseUrlInterceptor, sendTokenInterceptor, refreshTokenInterceptor])),
    MessageService,
    ConfirmationService,
    ConfirmDialog,
    DialogService,
    DatePipe,
    {
      provide: ErrorHandler,
      useClass: AppErrorHandler
    },
    provideNchlUi({
      icons: {
        nchlHome,
        nchlCheck,
        nchlKey,
        nchlCheckCircle,
        nchlWallet,
        nchlCalendar,
        lucideCog,
        lucideCreditCard,
        lucideSend,
        lucideShare2,
        lucideThumbsUp,
        lucideLink,
        lucideArrowRightLeft,
        lucideChartBar,
        lucideEraser,
        lucideBan,
        lucideRefreshCw,
        lucideShield,
        lucideSettings,
        lucideBuilding,
        lucideFileText,
        lucidePackage,
        lucideWrench,
        lucideBadgeDollarSign,
        lucideBanknote,
        lucidePercent,
        lucideFileMinus,
        lucideBell,
        lucideFileInput,
        lucideTruck,
        lucideMail,
        lucideSquare,
        lucideUserCheck,
        lucidePower,
        lucideFileCheck,
        lucideClock,
        lucideUserPen,
        lucideUser
      }
    }),
    provideAppInitializer(initTenantConfig),
  ]
};
